const ARCHIVE_SELECTOR = 'main.product-archive';
const BREAKPOINT = 1200;
const COOKIE = 'metro_archive_per_page';
const NARROW = '6';
const DESKTOP = '9';

function desiredPerPage() {
  return window.innerWidth < BREAKPOINT ? NARROW : DESKTOP;
}

function readCookie() {
  const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE}=([^;]*)`));
  return match ? match[1] : '';
}

function setCookie(value) {
  document.cookie = `${COOKIE}=${value};path=/;max-age=2592000;SameSite=Lax`;
}

function syncPerPage() {
  const want = desiredPerPage();
  const cur = readCookie();

  if (cur === want) {
    return false;
  }

  setCookie(want);

  const url = new URL(window.location.href);
  const newPath = url.pathname.replace(/\/page\/\d+\/?$/, '/');

  if (newPath !== url.pathname) {
    url.pathname = newPath;
    window.location.replace(url.toString());
  } else {
    window.location.reload();
  }

  return true;
}

function initProductArchivePerPage() {
  if (!document.querySelector(ARCHIVE_SELECTOR)) {
    return;
  }

  if (syncPerPage()) {
    return;
  }

  let resizeTimer;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncPerPage, 200);
  });
}

initProductArchivePerPage();
